import store from '@/services/store';
import { signOut } from '@/services/auth';

export default (defaultPrivacy = 'public') => (
  (to, from, next) => {
    const routePrivacy = to.meta.privacy ?? defaultPrivacy;
    const isUserLoggedIn = store.getters['auth/isLoggedIn'];

    if (routePrivacy === 'guest-only' && isUserLoggedIn) {
      next('/');
      return;
    }

    if (routePrivacy === 'private' && !isUserLoggedIn) {
      signOut(to.fullPath);
      next(false);
      return;
    }

    next();
  }
);
